import { createI18n } from 'vue-i18n'
import deepmerge from 'deepmerge'

import it from '@/locales/it.json'
import itCHScout from '@/locales/it-CH-scout.json'
import fr from '@/locales/fr.json'
import frCHScout from '@/locales/fr-CH-scout.json'
import en from '@/locales/en.json'
import enCHScout from '@/locales/en-CH-scout.json'
import de from '@/locales/de.json'
import deCHScout from '@/locales/de-CH-scout.json'
import rm from '@/locales/rm.json'
import rmCHScout from '@/locales/rm-CH-scout.json'

import vuetifyEn from 'vuetify/lib/locale/en'
import vuetifyDe from 'vuetify/lib/locale/de'
import vuetifyFr from 'vuetify/lib/locale/fr'
import vuetifyIt from 'vuetify/lib/locale/it'

const fallbackLocales = {
  rm: ['de'],
  default: ['en', 'de'],
}

const i18n = createI18n({
  locale: 'de',
  fallbackLocale: fallbackLocales,
  messages: deepmerge.all([
    // vuetify locales
    {
      en: { $vuetify: vuetifyEn },
      de: { $vuetify: vuetifyDe },
      fr: { $vuetify: vuetifyFr },
      it: { $vuetify: vuetifyIt },
    },

    // eCamp locales
    {
      it,
      'it-CH-scout': itCHScout,
      fr,
      'fr-CH-scout': frCHScout,
      en,
      'en-CH-scout': enCHScout,
      de,
      'de-CH-scout': deCHScout,
      rm,
      'rm-CH-scout': rmCHScout,
    },
  ]),
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  legacy: false,
})

Object.defineProperty(i18n, 'browserPreferredLocale', {
  get: function () {
    const languages = navigator.languages || [navigator.language]
    for (const language of languages) {
      if (this.availableLocales.includes(language)) {
        return language
      }

      const languageFallback = language.substring(0, 2)
      if (this.availableLocales.includes(languageFallback)) {
        return languageFallback
      }
    }
    return fallbackLocales.default
  },
})

export default i18n

/**
 * @type {{
 *   t: (key: string, ...args: any[]) => string,
 *   availableLocales: string[],
 *   locale: string,
 *   messages: {
 *     value: Record<string, any>
 *   }
 * }}
 */
const componentI18n = i18n.global

export { i18n, fallbackLocales, componentI18n }
